import { getCookie } from '@susu/cookie'

/**
 * Reads the storefront platform cookies set by the website when a visitor
 * lands on a Shopify or Salesforce environment. Used to compare engagement
 * across both platforms.
 *
 * @returns {platform: string, last_platform: string}
 */
export const getPlatformProperties = (): {
  platform: string
  last_platform: string
} => {
  const platform = getCookie('platform') ?? ''
  const lastPlatform = getCookie('last_platform') ?? ''

  return { platform, last_platform: lastPlatform }
}
